export default "__VITE_ASSET__BPUvPD$r__"